"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/KIFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_124)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_124`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#CE1126"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.208 17.3921C14.6911 17.3921 16.704 15.3792 16.704 12.8961C16.704 10.4131 14.6911 8.40015 12.208 8.40015C9.72496 8.40015 7.71204 10.4131 7.71204 12.8961C7.71204 15.3792 9.72496 17.3921 12.208 17.3921Z",
					fill: "#FCD116"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.328 5.87207L12.432 7.95207L14.72 8.47207L14.328 5.87207ZM10.208 5.88807L9.82402 8.53607L12.104 7.89607L10.208 5.88807ZM17.752 8.02407L14.976 8.70407L16.584 10.6001L17.752 8.02407ZM6.68802 7.88007L7.92802 10.4961L9.54402 8.68007L6.68802 7.88007ZM19.408 11.5041L16.656 10.7121L17.104 13.0721L19.408 11.5041ZM4.84802 11.2961L7.40002 12.8801L7.81602 10.6641L4.84802 11.2961Z",
					fill: "#FCD116"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 14H30V24H-6V14Z",
					fill: "#003F87"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 21.36C-4.8 21.36 -3.6 22.4 -2.4 22.4C-1.2 22.4 0 21.36 1.2 21.36C2.4 21.36 3.6 22.4 4.8 22.4C6 22.4 7.2 21.36 8.4 21.36C9.6 21.36 10.8 22.4 12 22.4C13.2 22.4 14.4 21.36 15.6 21.36C16.8 21.36 18 22.4 19.2 22.4C20.4 22.4 21.6 21.36 22.8 21.36C24 21.36 25.2 22.4 26.4 22.4C27.6 22.4 28.8 21.36 30 21.36V19.68C28.8 19.68 27.6 20.72 26.4 20.72C25.2 20.72 24 19.68 22.8 19.68C21.6 19.68 20.4 20.72 19.2 20.72C18 20.72 16.8 19.68 15.6 19.68C14.4 19.68 13.2 20.72 12 20.72C10.8 20.72 9.6 19.68 8.4 19.68C7.2 19.68 6 20.72 4.8 20.72C3.6 20.72 2.4 19.68 1.2 19.68C0 19.68 -1.2 20.72 -2.4 20.72C-3.6 20.72 -4.8 19.68 -6 19.68V21.36ZM-6 17.92C-4.8 17.92 -3.6 18.96 -2.4 18.96C-1.2 18.96 0 17.92 1.2 17.92C2.4 17.92 3.6 18.96 4.8 18.96C6 18.96 7.2 17.92 8.4 17.92C9.6 17.92 10.8 18.96 12 18.96C13.2 18.96 14.4 17.92 15.6 17.92C16.8 17.92 18 18.96 19.2 18.96C20.4 18.96 21.6 17.92 22.8 17.92C24 17.92 25.2 18.96 26.4 18.96C27.6 18.96 28.8 17.92 30 17.92V16.24C28.8 16.24 27.6 17.28 26.4 17.28C25.2 17.28 24 16.24 22.8 16.24C21.6 16.24 20.4 17.28 19.2 17.28C18 17.28 16.8 16.24 15.6 16.24C14.4 16.24 13.2 17.28 12 17.28C10.8 17.28 9.6 16.24 8.4 16.24C7.2 16.24 6 17.28 4.8 17.28C3.6 17.28 2.4 16.24 1.2 16.24C0 16.24 -1.2 17.28 -2.4 17.28C-3.6 17.28 -4.8 16.24 -6 16.24V17.92ZM-6 14.48C-4.8 14.48 -3.6 15.52 -2.4 15.52C-1.2 15.52 0 14.48 1.2 14.48C2.4 14.48 3.6 15.52 4.8 15.52C6 15.52 7.2 14.48 8.4 14.48C9.6 14.48 10.8 15.52 12 15.52C13.2 15.52 14.4 14.48 15.6 14.48C16.8 14.48 18 15.52 19.2 15.52C20.4 15.52 21.6 14.48 22.8 14.48C24 14.48 25.2 15.52 26.4 15.52C27.6 15.52 28.8 14.48 30 14.48V12.8C28.8 12.8 27.6 13.84 26.4 13.84C25.2 13.84 24 12.8 22.8 12.8C21.6 12.8 20.4 13.84 19.2 13.84C18 13.84 16.8 12.8 15.6 12.8C14.4 12.8 13.2 13.84 12 13.84C10.8 13.84 9.6 12.8 8.4 12.8C7.2 12.8 6 13.84 4.8 13.84C3.6 13.84 2.4 12.8 1.2 12.8C0 12.8 -1.2 13.84 -2.4 13.84C-3.6 13.84 -4.8 12.8 -6 12.8V14.48Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M8.65596 3.86401L8.56796 3.44001L10.36 3.14401C10.36 3.14401 7.95196 2.57601 7.15996 2.28801C6.01596 1.88001 5.85596 1.32001 5.85596 1.32001C5.85596 1.32001 9.43196 2.20001 11.04 2.20001C11.384 2.20001 12.064 3.05601 12.064 3.05601C12.064 3.05601 13.248 1.86401 13.816 1.82401C16.384 1.64001 19.144 1.31201 19.144 1.31201C19.144 1.31201 18.344 1.84801 17.864 1.99201C16.568 2.38401 13.816 2.92801 13.816 2.92801L13.432 3.52801H16.16L15.008 3.87201L15.6 4.42401C15.6 4.42401 14.976 4.09601 14.152 4.25601C13.584 4.36001 12.92 4.73601 12.32 4.89601C10.824 5.28001 9.92796 3.87201 9.92796 3.87201L8.65596 3.86401Z",
					fill: "#FCD116"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_124`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as KIFlag };
